import { Paper, Typography } from '@mui/material';
import React from 'react';

function SummaryCard({ value, label }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        px: 2,
        py: 1,
        borderRadius: 3,
        bgcolor: 'grey.50',
        mr: 1,
      }}>
      {/* The Big, Bold Value */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          lineHeight: 1.2,
        }}>
        {value || 'N/A'}
      </Typography>

      {/* The Small Grey Label */}
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
          letterSpacing: 0.5,
        }}>
        {label}
      </Typography>
    </Paper>
  );
}

export default SummaryCard;
